export default {
  state: {
    featureSubject: null,
    attentionSubject: null,
  },
  actions: {
    getFeatureSubject({commit}) {
      return axios.get('/api/v1/student/subject/feature')
        .then(({data : { data : subject}}) => {
          commit("SET_FEATURE_SUBJECT", subject)
        })
    },
    getAttentionSubject({commit}) {
      return axios.get('/api/v1/student/subject/attention')
      .then(({data : { data: subject }}) => {
        commit("SET_ATTENTION_SUBJECT", subject)
      })
    }
  },
  mutations: {
    SET_FEATURE_SUBJECT(state, payload) {
        state.featureSubject = payload;
    },
    SET_ATTENTION_SUBJECT(state, payload) {
        state.attentionSubject = payload;
    },
  }
}
